var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktokIcon = function SvgTiktokIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "evenodd",
    d: "M14.539 8H49.46A6.54 6.54 0 0 1 56 14.539V49.46A6.54 6.54 0 0 1 49.461 56H14.54A6.54 6.54 0 0 1 8 49.461V14.54A6.54 6.54 0 0 1 14.539 8Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC407A",
    fillRule: "evenodd",
    d: "M38.944 27.476A12.783 12.783 0 0 0 46.4 29.86v-5.348a7.53 7.53 0 0 1-1.566-.164v4.21c-2.78 0-5.353-.885-7.456-2.385v10.912c0 5.459-4.427 9.884-9.889 9.884a9.847 9.847 0 0 1-5.505-1.672 9.864 9.864 0 0 0 7.07 2.974c5.462 0 9.89-4.426 9.89-9.884V27.476Zm1.932-5.395a7.458 7.458 0 0 1-1.932-4.364v-.688H37.46a7.488 7.488 0 0 0 3.416 5.052ZM25.439 41.11a4.522 4.522 0 0 1 4.973-7.047v-5.466a10.061 10.061 0 0 0-1.565-.09v4.254a4.522 4.522 0 0 0-3.408 8.35Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M37.379 26.173a12.783 12.783 0 0 0 7.456 2.384v-4.209a7.493 7.493 0 0 1-3.959-2.268 7.484 7.484 0 0 1-3.415-5.05h-3.897v21.357a4.523 4.523 0 0 1-8.125 2.721 4.522 4.522 0 0 1 3.41-8.348v-4.253c-5.366.11-9.681 4.492-9.681 9.881 0 2.69 1.075 5.13 2.819 6.91a9.847 9.847 0 0 0 5.505 1.673c5.461 0 9.89-4.426 9.89-9.884l-.003-10.914Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#81D4FA",
    fillRule: "evenodd",
    d: "M44.835 24.35v-1.14a7.45 7.45 0 0 1-3.959-1.13 7.473 7.473 0 0 0 3.959 2.27Zm-7.375-7.32a7.286 7.286 0 0 1-.081-.615v-.688h-5.382v21.358a4.522 4.522 0 0 1-6.558 4.023 4.523 4.523 0 0 0 8.125-2.721V17.029h3.896Zm-8.613 11.477v-1.212c-.45-.062-.903-.092-1.358-.092-5.462 0-9.889 4.425-9.889 9.884a9.871 9.871 0 0 0 4.384 8.212 9.846 9.846 0 0 1-2.819-6.911c0-5.39 4.316-9.77 9.682-9.881Z",
    clipRule: "evenodd"
  })));
};
export default SvgTiktokIcon;